import accent from './accent';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { lightBlue } from '@material-ui/core/colors';
import opacity from './opacity';
import primary from './primary';

const action = {
    active: opacity.black60,
    'delete': fade( accent.redDark, .08 ),
    disabled: opacity.black26,
    disabledBackground: opacity.black14,
    focus: lightBlue[50],
    hover: opacity.black08,
    hoverOpacity: 0.08,
    selected: fade( primary[600], .14 ),
};
export default action;
